<template>
  <li class="stats__item" v-if="item.name !== 'Универсальный мужчина' && item.name !== 'Универсальная женщина'">
    <div class="stats__content">
      <span class="stats__icon" v-if="item.iconUrl">
        <img :src="apiImg + item.iconUrl" @click.prevent="" />
      </span>
      <div class="stats__controls">
        <p class="stats__name">{{ item.name }}</p>
        <span v-if="!mobile || !item.iconUrl" class="stats__bar"
          ><span class="stats__progress-bar" :style="`width: ${item.percentComplete}%`"
            ><p>{{ item.percentComplete }}%</p></span
          ></span
        >
      </div>
      <div
        class="stats__open"
        :class="{ 'stats__open--opened': subsystemsOpened }"
        v-if="item.children.length "
        @click.prevent="subsystemsOpened = !subsystemsOpened"
      ></div>
    </div>
    <div v-if="mobile && item.iconUrl" class="stats__bar__container">
      <span class="stats__bar"
          ><span class="stats__progress-bar" :style="`width: ${item.percentComplete}%`"
            ><p>{{ item.percentComplete }}%</p></span
          ></span
        >
    </div>
    <ul
      class="stats__subsystems"
      v-show="item.children.length && subsystemsOpened"
    >
      <ProgressItem
        v-for="(el, key) in item.children"
        :item="el"
        :key="key"
        :mobile="mobile"
        :class="{ stats__subitem: item.children }"
      />
    </ul>
  </li>
</template>

<script>
import ProgressItem from "../components/ProgressItem.vue";
import { mapGetters } from "vuex";
export default {
  name: "ProgressItem",
  components: {
    ProgressItem,
  },
  data() {
    return {
      subsystemsOpened: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isChild: {
      type: Boolean,
      required: false,
    },
    mobile: Boolean    
  },

  computed: {
    ...mapGetters({
      apiImg: "apiImg",
    }),
  },
  methods: {
    openSubsystems(id) {
      this.subsystemsOpened[id] = !this.subsystemsOpened[id];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars.scss";

.stats__subitem .stats__content .stats__controls .stats__name {
  font-weight: 400;
}

.stats__item {
  display: flex;
  flex-flow: column;
  background: #f3f4f6;
  border-radius: 25px;
  padding: 15px 0 15px !important;
}

.stats__content {
  position: relative;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}

.stats__open {
  position: absolute;
  top: calc(50% - 6px);
  right: 30px;
  display: flex;
  cursor: pointer;
  width: 8px;
  height: 12px;
  margin: 0px;
  padding: 10px;
  transform: rotate(-90deg);
  background: url("~@/assets/img/small-arrow.svg") no-repeat;
  background-position: center;
  z-index: 3;
}

.stats__open--opened {
  transform: rotate(90deg);
}

.stats__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  min-width: 45px;
  height: 45px;
  margin: 0 0 0 15px;
  border-radius: 50%;
  border: 1px solid #81b6e4;
  background: #fff;

  & img {
    width: 28px;
    height: 28px;
  }
}

.stats__controls {
  display: flex;
  flex-flow: column;
  width: max-content;
  flex-grow: 1;
  padding: 0 80px 0 40px;
}

.stats__name {
  display: flex;
  height: min-content;
  margin: 0 0 11px 0 !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
}

.stats__bar {
  display: flex;
  flex-flow: row;
  width: 100%;
  min-width: 100%;
  height: 22px;
  margin: 0;
  background: #cacdd3;
  border-radius: 50px;
}

.stats__progress-bar {
  display: flex;
  flex-flow: row;
  // width: 35%;
  min-width: 0px;
  padding: 0;
  box-sizing: content-box;
  height: 22px;
  background: #4854fe;
  color: #fff;
  border-radius: 50px;

  & p {
    padding: 0 15px;
  }
}

.stats__subsystems {
  display: flex;
  width: 100%;
  flex-flow: column;
  margin: 30px 0 0;
  padding: 0 !important;

  & .stats__item {
    min-width: 100%;
    padding: 15px 0 !important;
    border-bottom: 0.5px solid #c6cbd7;
    border-radius: 0;
  }

  & .stats__controls {
    padding: 0;
    flex-flow: row;
  }

  & .stats__name {
    margin: 0 0 0 15px !important;
  }

  & .stats__bar {
    width: 20%;
    min-width: 20%;
    margin: 0 80px 0 auto;
  }
}

@media screen and (max-width: 960px) {
  .stats__open {
    right: 10px;
  }

  .stats__controls {
    padding: 0 40px 0 20px;
  }

  .stats__subsystems {
    & .stats__name {
      margin: 0 0 0 10px !important;
    }

    & .stats__bar {
      margin: 0 10px;
    }
  }

  .stats__bar__container {
    margin-top: 10px;
    padding: 0 30px 0 10px;

    & .stats__bar {
      width: 94%;
      min-width: 94%;
    }
  }
}
</style>
